/* eslint-disable import/no-anonymous-default-export */
import siteConfig from "../siteConfig";

export default {
  path: "/workshops",
  shortTitle: "Workshops",
  title: "Workshop requests and attendance",
  category: "Products and care",
  summary: "Specific rules for the botanical printmaking item that actually exists in the catalog.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "A checkout is a request",
      body: [
        "The catalog includes Botanical Print Making Workshop admission for one participant. The project does not contain a scheduling or ticketing backend and does not confirm a date, venue, instructor, duration or age limit. Payment return alone therefore does not confirm a place. Customer care must verify payment, capacity and the session details in writing.",
      ],
    },
    {
      heading: "Before confirmation",
      body: [
        `A prospective participant should disclose only the practical accessibility adjustment, supervision need or material sensitivity necessary to plan participation. ${siteConfig.brandName} will confirm the available arrangement before treating attendance as agreed. If a suitable arrangement or session cannot be offered, the request should be cancelled and any captured amount returned through the original payment route.`,
      ],
    },
    {
      heading: "Tools, clothing and conduct",
      body: [
        "Relief-print carving tools are sharp and ink can stain. Participants must follow the facilitator's safety briefing, use guards and tools only as instructed, keep food and drink away from the work area, and wear clothing suitable for water-based ink. Unsafe, threatening or disruptive conduct may require a participant to stop, subject to fair assessment and mandatory rights.",
      ],
    },
    {
      heading: "Changes and cancellation",
      body: [
        `Email promptly if attendance becomes impossible. No fixed transfer or cancellation deadline is published because no schedule or capacity process has been supplied. If ${siteConfig.brandName} cancels a confirmed workshop and no acceptable replacement is agreed, the workshop amount should be refunded. Personal travel or accommodation should not be booked until written session confirmation is received; no reimbursement promise for those costs is made.`,
      ],
    },
  ],
};
